const MD_BREAKPOINT = 744;

export default function initProjectSticky() {
  const stickyElements = document.querySelectorAll(
    ".project-sticky, .publication-sticky"
  );
  if (!stickyElements.length) return;

  const navbarWrapper = document.querySelector(".navbar-wrapper");

  function getNavbarHeight() {
    if (!navbarWrapper) return 0;
    const navbarContainer = navbarWrapper.querySelector(".navbar-container");
    return navbarContainer ? navbarContainer.offsetHeight : 0;
  }

  function isNavbarHidden() {
    if (!navbarWrapper) return false;
    return (
      navbarWrapper.classList.contains("scrolled") &&
      navbarWrapper.classList.contains("scroll-down")
    );
  }

  stickyElements.forEach((sticky) => {
    const container =
      sticky.closest(".project-container") ||
      sticky.closest(".publication-container");
    let placeholder = null;
    let savedPosition = null;

    function handleSticky() {
      if (window.innerWidth >= MD_BREAKPOINT) {
        sticky.classList.remove("is-sticky", "is-hidden", "navbar-hidden");
        sticky.style.position = savedPosition || "";
        savedPosition = null;
        if (placeholder) {
          placeholder.remove();
          placeholder = null;
        }
        return;
      }

      const spacingSm = 8;
      const navbarHeight = getNavbarHeight();
      const navbarHidden = isNavbarHidden();

      // Update CSS variable for other components
      document.documentElement.style.setProperty(
        "--navbar-height",
        `${navbarHeight}px`
      );

      const checkElement = placeholder || sticky;
      const rect = checkElement.getBoundingClientRect();

      const stickyTop = navbarHidden ? spacingSm : navbarHeight + spacingSm;
      const shouldBeSticky = rect.top <= stickyTop;

      let isWithinContainer = true;
      if (container) {
        const containerRect = container.getBoundingClientRect();
        isWithinContainer =
          containerRect.bottom > sticky.offsetHeight + stickyTop;
      }

      if (shouldBeSticky && isWithinContainer) {
        if (!sticky.classList.contains("is-sticky")) {
          // Create placeholder to maintain layout space
          if (!placeholder) {
            placeholder = document.createElement("div");
            placeholder.style.height = sticky.offsetHeight + "px";
            sticky.parentNode.insertBefore(placeholder, sticky);
          }
          // Add navbar-hidden BEFORE is-sticky to prevent jump
          if (navbarHidden) {
            sticky.classList.add("navbar-hidden");
          }
          sticky.classList.add("is-sticky");
          // Override inline position set by dropdown.js
          savedPosition = sticky.style.position;
          sticky.style.position = "fixed";
        } else {
          if (navbarHidden) {
            sticky.classList.add("navbar-hidden");
          } else {
            sticky.classList.remove("navbar-hidden");
          }
        }
        sticky.classList.remove("is-hidden");
      } else if (!shouldBeSticky) {
        sticky.classList.remove("is-sticky", "is-hidden", "navbar-hidden");
        // Restore original inline position (e.g. relative from dropdown.js)
        sticky.style.position = savedPosition || "";
        savedPosition = null;
        if (placeholder) {
          placeholder.remove();
          placeholder = null;
        }
      } else if (!isWithinContainer) {
        sticky.classList.add("is-hidden");
      }
    }

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleSticky();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", handleSticky);
    handleSticky();
  });
}
